<template>
	<div class="cr-body-content">
		<flexbox class="content-header">
			<el-input 
				class="search-container" 
				v-model="searchContent" 
				:placeholder="placeholder">
				<el-button 
					slot="append" 
					@click.native="searchInput" 
					icon="el-icon-search"></el-button>
			</el-input>
		</flexbox>

		<el-table 
			class="cr-table" 
			ref="relativeTable" 
			:data="list" 
			v-loading="loading" 
			:height="250" 
			stripe 
			border
			highlight-current-row 
			style="width: 100%" 
			@select-all="selectAll" 
			@selection-change="handleSelectionChange"
			@row-click="handleRowClick">
			<el-table-column 
				v-if="fieldList.length > 0"
				show-overflow-tooltip 
				type="selection" 
				align="center" 
				width="55"></el-table-column>
			<el-table-column 
				v-if="fieldList.length > 0"
				v-for="(item, index) in fieldList" 
				:key="index" 
				show-overflow-tooltip
				:prop="item.prop" 
				:label="item.label" 
				:width="150" 
				:formatter="fieldFormatter">
			</el-table-column>
		</el-table>

		<div class="table-footer">
			<el-button @click.native="changePage('up')" :disabled="currentPage <= 1">上一页</el-button>
			<el-button @click.native="changePage('down')" :disabled="currentPage >= totalPage">下一页</el-button>
		</div>
	</div>
</template>
<script>
	// API
	import { crmCustomerNopool } from '@/api/customer/customer'
	import { crmLawcaseIndex } from '@/api/lawcase/lawcase'
	import { crmContractIndex } from '@/api/contract/contract'
	import { filedGetField } from '@/api/setting/setting'
	import moment from 'moment'
	import { getDateFromTimestamp,moneyFormat } from '@/utils'
	export default {
		data() {
			return {
				loading: false, // 加载进度
				filterArr:[],
				searchContent: '', // 输入内容
				list: [], // 表数据
				fieldList: [], // 表头数据
				currentPage: 1, // 当前页数
				totalPage: 1, //总页数
				/** 格式化规则 */
				formatterRules: {},
				selectedItem: [], // 勾选的数据 点击确定 传递给父组件
			}
		},
		props: {
			show: {
				type: Boolean,
				default: false
			},
			/** 多选框 只能选一个 */
			radio: {
				type: Boolean,
				default: true
			},
			/** 没有值就是全部类型 有值就是当个类型 */
			crmType: {
				type: String,
				default: ''
			},
			/** 已选信息 */
			selectedData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			/**
			 * default 默认  condition 固定条件筛选
			 * relative: 相关 添加
			 */
			action: {
				type: Object,
				default: () => {
					return {
						type: 'default',
						data: {}
					}
				}
			}
		},
		watch: {
			crmType: function(newValue, oldValue) {
				if (newValue != oldValue) {
					this.fieldList = []
					this.getFieldList()
				}
			},
			action: function(val) {
				if (this.action != val) {
					this.list = [] // 表数据
					this.fieldList = [] // 表头数据
					this.currentPage = 1 // 当前页数
					this.totalPage = 1 //总页数
					this.getFieldList()
				}
			},
			show: {
				handler(val) {
					if (val && this.fieldList.length == 0) {
						this.getFieldList()
					}
				},
				deep: true,
				immediate: true
			},
			// 选择
			selectedData: function() {
				this.checkItemsWithSelectedData()
			}
		},
		computed: {
			placeholder() {
				if(this.crmType == "lawcase"){
					return "请输入案件名称"
				}else{
					return "请输入客户姓名"
				} 
			}
		},
		methods: {
			/** 获取字段 */
			getFieldList() {
				if (this.fieldList.length == 0) {
					let crmType
					crmType = this.crmType

					var params = {
						types: "crm_" + crmType,
						module: 'crm',
						action: 'index'
					}
					params.actiontype = 7

					params.controller = this.crmType
					filedGetField(params)
						.then(res => {
							for (let index = 0; index < res.data.length; index++) {
								const element = res.data[index]
								/** 获取需要格式化的字段 和格式化的规则 */
								if (element.form_type === 'date') {
									this.formatterRules[element.field] = {
										formatter: function fieldFormatter(time) {
											if (time == '0000-00-00') {
												time = ''
											}
											if (time) {
												return moment(getDateFromTimestamp(time)).format(
													'YYYY-MM-DD'
												)
											}


										}
									}
								} else if (element.form_type === 'datetime') {
									this.formatterRules[element.field] = {
										formatter: function fieldFormatter(time) {
											if (time == 0 || !time) {
												return ''
											}
											return moment(getDateFromTimestamp(time)).format(
												'YYYY-MM-DD HH:mm:ss'
											)
										}
									}
								} else if (element.form_type === 'user' || element.form_type === 'user-multiple') {
									this.formatterRules[element.field] = {
										type: 'crm',
										formatter: function fieldFormatter(info) {
											if (info) {
												var content = ''
												for (let index = 0; index < info.length; index++) {
													const element = info[index]
													content = content + element.username + (index === (info
														.length - 1) ? '' : ',')
												}
												return content
											}
											return ''
										}
									}
								} else if (element.form_type === 'float') {
									this.formatterRules[element.field] = {
										type: 'floatnumber',
										formatter: function fieldFormatter(info) {
											return moneyFormat(info)
										}
									}
								} else if (element.form_type === 'select-multiple') {
									this.formatterRules[element.field] = {
										type: 'array',
										formatter: function fieldFormatter(info) {
											return info
										}
									}
								}

								var width = 0
								if (!element.width) {
									if (element.form_type == 'datetime') {
										width = 170
									} else if (element.form_type == 'textarea') {
										width = 350
									} else {
										width = 115
									}
								} else {
									width = element.width
								}

								this.fieldList.push({
									prop: element.field,
									label: element.name,
									width: width
								})

							}

							// 获取好字段开始请求数据
							this.getList()
						})
						.catch(() => {
							this.loading = false
						})
				} else {
					// 获取好字段开始请求数据
					this.getList()
				}
			},

			/** 获取列表数据 */
			getList() {
				this.loading = true
				var crmIndexRequest = this.getIndexRequest()
				var params = {
					page: this.currentPage,
					limit: 15
				}
				if (this.filterArr.length > 0) {
					params['heightSearch'] = this.filterArr
				}
				if (this.id) {
					params.id = this.id
				}
				crmIndexRequest(params).then(res => {
					this.list = res.data.list.map(element => {
						element.show = false
						return element
					})
					/**
					 *  如果已选择的有数据
					 */
					if (this.selectedData[this.crmType]) {
						this.checkItemsWithSelectedData()
					} else {
						// this.list = res.data.list
						this.list = res.data.list.map(element => {
							element.show = false
							return element
						})
					}

					
					this.totalPage = Math.ceil(res.data.count / 15)
					this.$refs['relativetable'].doLayout()
					this.loading = false
				}).catch(() => {
					this.loading = false
				})
			},

			/** 获取列表请求 */
			getIndexRequest() {
				if (this.crmType === 'customer') {
					return crmCustomerNopool
				}else if (this.crmType === 'lawcase') {
					return crmLawcaseIndex
				}else if (this.crmType === 'contract') {
					return crmContractIndex
				}
			},

			/** 格式化字段 */
			fieldFormatter(row, column) {
				// 如果需要格式化
				var aRules = this.formatterRules[column.property]
				if (aRules) {
					if (aRules.type === 'crm') {
						if (column.property) {
							// return aRules.formatter(row[column.property]) || '--'
							return aRules.formatter(row[column.property + '_info']) || '--'
						} else {
							return ''
						}
					} else {
						return aRules.formatter(row[column.property]) || '--'
					}
				}
				return row[column.property] || '--'
			},

			// 进行搜索操作
			searchInput() {
				this.filterArr = [{
					"search_v":this.searchContent,
					"search_f": this.crmType == "contract"  ? "customer" : "name",
					"search_t":"text"
				}]
				this.getList()
			},
			
			// 上一页 &&下一页
			changePage(type) {
				console.log(type);
				if (type == 'up') {
					this.currentPage = this.currentPage - 1
				} else if (type == 'down') {
					this.currentPage = this.currentPage + 1
				}
				if (this.currentPage <= this.totalPage && this.currentPage >= 1) {
					this.getList()
				}
			},

			// 	当用户手动勾选全选 Checkbox 时触发的事件
			selectAll() {},

			//当选择项发生变化时会触发该事件
			handleSelectionChange(val) {
				if (this.radio) {
					// this.$refs.relativeTable.clearSelection();
					val.forEach((row, index) => {
						if (index === val.length - 1) return
						this.$refs.relativeTable.toggleRowSelection(row, false)
					})
					if (val.length === 0) {
						this.selectedItem = []
					} else {
						this.selectedItem = val.length === 1 ? val : [val[val.length - 1]]
					}
				} else {
					this.selectedItem = val
				}
				this.$emit('changeCheckout', {
					data: this.selectedItem,
					type: this.crmType
				})
			},

			// 当某一行被点击时会触发该事件
			handleRowClick(row, column, event) {},

			// 标记选择数据
			checkItemsWithSelectedData() {
				let selectedArray = this.selectedData[this.crmType]
				let selectedRows = []
				this.list.forEach((item, index) => {
					selectedArray.forEach((selectedItem, selectedIndex) => {
						if (
							item['id'] == selectedItem['id']
						) {
							selectedRows.push(item)
						}
					})
				})
				
				this.$nextTick(() => {
					this.$refs.relativeTable.clearSelection()
					selectedRows.forEach(row => {
						this.$refs.relativeTable.toggleRowSelection(row, true)
					})
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.cr-body-content {
		position: relative;
		background-color: white;
		border-bottom: 1px solid #eee;
	}

	.content-header {
		position: relative;
		padding: 10px 20px;

		.search-container {
			margin: 0 20px;
			width: 200px;
		}

		.create-button {
			position: absolute;
			right: 10px;
			top: 15px;
		}
	}

	//表尾 上一页按钮
	.table-footer {
		padding: 8px 20px;
	}

	.el-table /deep/ thead th {
		font-weight: 400;
		font-size: 12px;
	}

	.el-table /deep/ tbody tr td {
		font-size: 12px;
	}

	.el-table /deep/ thead .el-checkbox {
		display: none;
	}
</style>